"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUDGET_STICKY_TOP_HEIGHT = exports.BUDGET_ANNUAL_COPY_OPTIONS = exports.BUDGET_ANNUAL_MONTHS = exports.BUDGET_ANNUAL_SUBVIEWS = exports.BUDGET_VIEWS = exports.BUDGET_ANNUAL_INVISIBLE_AMOUNT_SYMBOL = void 0;
exports.BUDGET_ANNUAL_INVISIBLE_AMOUNT_SYMBOL = '-';
exports.BUDGET_VIEWS = {
    monthly: {
        key: 'monthly',
        label: 'Monthly View',
    },
    annual: {
        key: 'annual',
        label: 'Annual View',
    },
};
exports.BUDGET_ANNUAL_SUBVIEWS = {
    details: {
        key: 'details',
        label: 'Details',
        amountKey: 'balanceAmount',
        columnLabel: 'Balance',
    },
    budget: {
        key: 'budget',
        label: 'Budget only',
        amountKey: 'budgetAmount',
        columnLabel: 'Budget',
    },
    actual: {
        key: 'actual',
        label: 'Actuals only',
        amountKey: 'actualAmount',
        columnLabel: 'Actual',
    },
    balance: {
        key: 'balance',
        label: 'Balance only',
        amountKey: 'balanceAmount',
        columnLabel: 'Balance',
    },
};
exports.BUDGET_ANNUAL_MONTHS = [
    {
        number: 1,
        shortName: 'Jan',
        name: 'January',
    },
    {
        number: 2,
        shortName: 'Feb',
        name: 'February',
    },
    {
        number: 3,
        shortName: 'Mar',
        name: 'March',
    },
    {
        number: 4,
        shortName: 'Apr',
        name: 'April',
    },
    {
        number: 5,
        shortName: 'May',
        name: 'May',
    },
    {
        number: 6,
        shortName: 'Jun',
        name: 'June',
    },
    {
        number: 7,
        shortName: 'Jul',
        name: 'July',
    },
    {
        number: 8,
        shortName: 'Aug',
        name: 'August',
    },
    {
        number: 9,
        shortName: 'Sep',
        name: 'September',
    },
    {
        number: 10,
        shortName: 'Oct',
        name: 'October',
    },
    {
        number: 11,
        shortName: 'Nov',
        name: 'November',
    },
    {
        number: 12,
        shortName: 'Dec',
        name: 'December',
    },
];
exports.BUDGET_ANNUAL_COPY_OPTIONS = {
    pastMonths: 'pastMonths',
    restOfYear: 'restOfYear',
    currentMonth: 'currentMonth',
    wholeYear: 'wholeYear',
};
exports.BUDGET_STICKY_TOP_HEIGHT = {
    rowAmountType: 46,
    rowProgressBar: 78,
};
